import { SettingsItemId } from 'settings/Settings.types';

import {
  SettingsDashboardItem,
  SettingsDashboardItemProps
} from 'settings/components/SettingsDashboardItem';
import { ExportDashboardItem } from 'settings/components/ExportDashboardItem';
import { ChurnCompanyDashboardItem } from 'settings/components/ChurnCompanyDashboardItem';
import { EnableCompanyDashboardItem } from 'settings/components/EnableCompanyDashboardItem';
import { SurveyBuilderDashboardItem } from 'settings/components/SurveyBuilderDashboardItem';

type SettingsTileElement = (props: SettingsDashboardItemProps) => JSX.Element;
type SpecialItems = { readonly [Key in SettingsItemId]?: SettingsTileElement };

export function getDashboardItemComponent(
  id: SettingsItemId
): SettingsTileElement {
  const specialItems: SpecialItems = {
    disable_company: ChurnCompanyDashboardItem,
    enable_company: EnableCompanyDashboardItem,
    exports: ExportDashboardItem,
    survey_builder: SurveyBuilderDashboardItem,
    service_recovery: SurveyBuilderDashboardItem,
  };

  const specialItem = specialItems[id];
  if (specialItem !== undefined) return specialItem;

  return SettingsDashboardItem;
}
